'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('modalService', ['$q', '$uibModal', function($q, $uibModal) {
      //returns promise
      function authenticateWithPinScreen(options) {
        var modal = $uibModal.open({
          templateUrl: 'views/toolbox/enter-pin-screen.html',
          controller: 'checkPinScreenController',
          windowClass:'standard-modal-window',
          keyboard:false,
          resolve: {
            authOptions: function() {
              return options;
            }
          },
          backdrop:'static'
        });

        return modal
          .result['finally'](function() {
            modal = undefined;
          });
      }

      //Returns modalInstance
      function showSpinnerScreen(spinnerMessage) {
        var modalDefinition = {
          controller: 'SpinnerModalController',
          templateUrl: 'views/toolbox/spinnerModal.html',
          resolve: {
            text: function() {
              return spinnerMessage;
            }
          },
          windowClass: 'invisible-modal',
          keyboard: false,
          backdrop: 'static'
        };

        var modal = $uibModal.open(modalDefinition);
        modal
          .result['finally'](function() {
            modal = undefined;
          });

        return modal;
      }

      //returns promise
      function showNoPINFoundScreen(feature) {
        var modal = $uibModal.open({
          templateUrl: 'views/toolbox/no-pin-found-screen.html',
          controller: 'noPinFoundScreenController',
          windowClass:'standard-modal-window',
          keyboard:false,
          backdrop:'static',
          resolve: {
            feature: function() {
              return feature;
            }
          }
        });

        return modal
          .result['finally'](function() {
            modal = undefined;
          });
      }

      function showNotification(head, body) {
        var modalDefinition = {
          controller: 'notificationModalController',
          templateUrl: 'views/common/notifiaction-modal.html',
          resolve: {
            modalHead: function() {
              return head;
            },
            modalBody: function() {
              return body;
            }
          },
          windowClass: 'standard-modal-window',
          openedClass: 'notification-modal'
        };
        var modalInstance = $uibModal.open(modalDefinition);
        modalInstance.result['finally'](function() {
          modalInstance = undefined;
        });
        return modalInstance.result;
      }

      function showConfirmAction(options) {
        var modalDefinition = {
          controller: 'modalConfirmController',
          templateUrl: 'views/common/modal-confirm-dialog.html',
          resolve: {
            options: function() {
              return {
                title: options.title,
                line1: options.line1,
                line1part2bold: options.line1part2bold,
                line2: options.line2,
                okText: options.okText ? options.okText : 'Yes, continue',
                cancelText: options.okText ? options.okText : 'Cancel'
              };
            }
          },
          windowClass:'confirm-modal'
        };
        var modalInstance = $uibModal.open(modalDefinition);
        modalInstance.result['finally'](function() {
          modalInstance = undefined;
        });
        return modalInstance.result;
      }

      return {
        authenticateWithPinScreen : authenticateWithPinScreen,
        showSpinnerScreen : showSpinnerScreen,
        showNoPINFoundScreen : showNoPINFoundScreen,
        showNotification: showNotification,
        showConfirmAction: showConfirmAction
      };
    }]);
})(angular);

